import { render } from "./FreeQuotaAction.vue?vue&type=template&id=321aaa6e&scoped=true"
import script from "./FreeQuotaAction.vue?vue&type=script&lang=js"
export * from "./FreeQuotaAction.vue?vue&type=script&lang=js"

import "./FreeQuotaAction.vue?vue&type=style&index=0&id=321aaa6e&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321aaa6e"]])

export default __exports__